var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext } from "react";
import { rejectOnResErr } from "@iscr/xAppLib/helpers/rejectOnResErr";
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";
import API_service from "xAppLib/providers/API_service";
export const ContentfulContext = createContext(null);
export const useContentfulProvider = () => {
    const context = useContext(ContentfulContext);
    if (context === null) {
        throw new Error("useContentfulProvider must be used within <ContentfulProvider/>");
    }
    return context;
};
export const ContentfulProvider = ({ children, space, preview }) => {
    const getEntry = useCallback((params) => __awaiter(void 0, void 0, void 0, function* () { return yield API_service.load_data("cms/getEntries", params).then(rejectOnResErr); }), []);
    const content = _jsx(ContentfulContext.Provider, { value: { getEntry }, children: children });
    if (!preview)
        return content;
    return (_jsx(ContentfulLivePreviewProvider, { locale: "en-AU", enableInspectorMode: true, debugMode: true, enableLiveUpdates: true, space: space, targetOrigin: "https://app.contentful.com", children: content }));
};
